// extracted by mini-css-extract-plugin
export default {"popup":"DKwIrE5J_nFD9W4QKU3z"};